import StringHelper from '../../utils/StringHelper';

function MountFilter(payload) {
    try {
        const filter = {
            tenant: payload.tenant,
            vinculo: payload.despesa ? ['funcionario', 'fornecedor'] : '',
        };

        if (payload.nameToSearchBase) {
            const nameToSearch = payload.nameToSearchBase.replace(/[^\d\w]+/g, '').toUpperCase();
            // CNPJ alfanumérico: 12 posições [A-Z0-9] + 2 dígitos verificadores.
            const isCnpjAlfanumerico = /^[A-Z0-9]{12}\d{2}$/.test(nameToSearch);
            if (!isNaN(nameToSearch) || isCnpjAlfanumerico) {
                const cpf = StringHelper.formatToCpf(nameToSearch);
                const cnpj = StringHelper.formatToCnpj(nameToSearch);


                filter.doc1 = cpf;
                filter.doc2 = cnpj;
            } else {
                filter.nome = payload.nameToSearchBase;
                filter.email = payload.nameToSearchBase;
            }
        }
        return filter;
    } catch (e) {
        console.log(e);
    }
}

export default MountFilter;